import { useMemo } from "react";
import { Input } from "./useInput";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function useRequiredFields(inputs: Input<any>[]) {
  const isDisabled = useMemo(() => {
    const hasError = inputs.some((input) => input.isError);
    const hasData = inputs.every((input) => input.value);

    return hasError || !hasData;
  }, [inputs]);
  return isDisabled;
}
export default useRequiredFields;
